<template>
  <div class="monit-page report-table">
    <div
      class="no-report row center middle-lg middle-sm middle-xs"
      v-show="!hasReport"
    >
      <div class="col-xs-12 center-xs">
        <logo-icon customWidth="10em" fillColor="#3d9161c4" />
        <div class="btn-report">
          <b-btn variant="orange" @click="openReportForm"
            >GERAR RELATÓRIO</b-btn
          >
        </div>
      </div>
    </div>
    <b-modal
      centered
      ref="progressWait"
      no-close-on-backdrop
      no-close-on-esc
      size="sm"
      hide-header
      body-bg-variant=""
      hide-footer
      rounded
    >
      <div class="center-xs">
        <h6>Aguarde</h6>
        <b-progress :max="progressMax" height="1rem" :striped="false">
          <b-progress-bar :value="progress" variant="success"> </b-progress-bar>
        </b-progress>
        <!-- <br /> -->
        <div class="">
          {{ logsProgressBar }}
        </div>
      </div>
    </b-modal>

    <div v-show="hasReport" class="report">
      <div class="row align-items-center mr-2 mt-lg-2" v-if="!mobile">
        <div class="col-xs-6 column details-info m-1 pt-2">
          <p><strong>Tipo:</strong> {{ parseType }}</p>
          <p v-if="this.reportData.type != 'daily'">
            <strong>Intervalo:</strong>
            {{
              reportData && reportData.interval_formatted
                ? reportData.interval_formatted
                : interval
            }}
          </p>
          <p v-if="this.reportData.type != 'daily'">
            <strong>Período:</strong> {{ start }} à {{ end }}
          </p>
          <p v-if="this.reportData.observation">
            <strong>Observação:</strong> {{ reportData.observation }}
          </p>
        </div>
        <div class="col-xs end-xs">
          <b-btn
            variant="orange"
            @click="openReportForm"
            size="sm"
            pill
            class=""
          >
            <report-icon style="font-size: 1em; vertical-align: -3%" title="" />
            GERAR NOVO RELATÓRIO
          </b-btn>
        </div>
      </div>
      <div v-if="mobile">
        <div class="row mt-1">
          <div class="col-xs-12 column details-info m-2">
            <p><strong>Tipo:</strong> {{ parseType }}</p>
            <p v-if="this.reportData.type != 'daily'">
              <strong>Intervalo:</strong> {{ interval }}
            </p>
            <p v-if="this.reportData.type != 'daily'">
              <strong>Período:</strong>
              {{ reportData.start ? formatDateTime(reportData.start) : "?" }} à
              {{ reportData.end ? formatDateTime(reportData.end) : "?" }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-xs center-xs mt-1">
            <b-btn variant="orange" @click="openReportForm" size="sm"
              ><report-icon
                style="font-size: 1em; vertical-align: -3%"
                title=""
              />
              GERAR NOVO RELATÓRIO</b-btn
            >
          </div>
        </div>
      </div>
      <div class="box mt-2" v-if="showTabulator && !showEspecialReports">
        <Tabulator
          :data="tableData"
          :reportTitle="parseType"
          :columns="columns"
        />
      </div>
      <div v-if="showEspecialReports">
        <div
          class="col-xs-12 column box mt-4 d-flex flex-column"
          v-if="reportData && reportData.group == 'management'"
        >
          <management-daily v-if="tableData.length" :table-data="tableData" />

          <div v-else>Não foi possível gerar o relatório diário</div>
        </div>

        <!-- <div class="col-xs-12 column box mt-4 d-flex flex-column" v-if="reportData.equipment === 'sensor' && (reportData.type === 'measure-hourly' || reportData.type === 'measure-daily')">
          <div class="options-download row mb-2 col-md-12 justify-content-center p-0">
            <b-button
              id="download-csv"
              pill
              size="sm"
              variant="info"
              class="m-1 align-items-center"
              @click="downloadCSVEspecialReports"
            >
              <csv-icon style="font-size: 1.1em; vertical-align: -3%" />
              Download CSV
            </b-button>
            <b-button
              id="download-xlsx"
              @click="downloadXLSXEspecialReports"
              pill
              size="sm"
              variant="info "
              class="m-1 align-items-center"
            >
              <excel-icon style="font-size: 1.1em; vertical-align: -3%" />
              Download XLSX
            </b-button>
            <b-button
              id="download-pdf"
              @click="downloadPDFEspecialReports"
              pill
              size="sm"
              variant="info align-items-center"
              class="m-1"
            >
              <pdf-icon style="font-size: 1.1em; vertical-align: -3%" />
              Download PDF
            </b-button>
          </div>

          <data-table
            v-if="columns.length"
            :table-data="tableData"
            ref="dataTable"
            sticky-header
            max-height-table="70vh"
            :static-columns="columns"
            :file-prefix="`media_sensores`"
            />

          <div v-else>
            Não foi possível gerar o relatório diário
          </div>

          <div class="my-1"></div>
        </div> -->
      </div>
    </div>

    <report-form
      :show-form="showForm"
      :management-access="managementAccess"
      @close-form="showForm = false"
      @make-report="makeReport"
    />
  </div>
</template>

<script>
import moment from "moment";
import calcManagement from "@/mixins/calcManagement";
import ManagementDaily from "./components/ManagementDaily.vue";
import DataTable from "@/pages/components/shared/table/DataTable.vue";
import { reports, stations, management } from "@/api";
import {
  organizeToTable,
  removeItemsWithoutLog,
} from "@/pages/components/monit/report";

// import testinho from "./test2";

import Tabulator from "./components/Tabulator";
export default {
  name: "report-table",
  mixins: [calcManagement],
  created() {
    this.$emit("title-change", "Relatório");
  },
  components: {
    Tabulator,
    ManagementDaily,
    DataTable,
  },
  props: {
    mobile: {
      type: Boolean,
      required: true,
    },
    managementAccess: Boolean,
  },
  data() {
    return {
      showEspecialReports: false,
      showForm: false,
      hasReport: false,
      showTabulator: false,
      progressBar: false,
      progressMax: 1,
      progressbarWait: {},
      progress: 0,
      // retryForm: false,
      reportData: {
        about: {
          type: null,
          start: null,
          end: null,
        },
      },
      selected: [],
      tableData: [],
      columns: [],
      logsProgressBar: "",
    };
  },
  computed: {
    parseType() {
      let type = this.reportData.type;
      let group = this.reportData.group;
      let organization = this.reportData.organization;
      let measure = "?";
      let org = "?";

      if (!group) {
        group = "";
      } else if (group == "management") {
        group = "Manejo";
      }

      if (type) {
        if (type == "flow") measure = "Vazão";
        else if (type == "volume") measure = "Volume";
        else if (type == "open") measure = "Abertura";
        else if (type == "modo") measure = "Manual/Automático";
        else if (type == "battery") measure = "Bateria";
        else if (type == "stat") measure = "Status";
        else if (type == "measure") measure = "Medições";
        else if (type == "measure-hourly") measure = "Medições por hora";
        else if (type == "measure-daily") measure = "Medições por dia";
        else if (type == "station-reads") measure = "Leituras da estação";
        else if (type == "daily") {
          measure = "Relatório Diário de " + group;
          org = `${
            this.tableData && this.tableData.length
          } setores em progresso`;
        }
      }
      if (organization) {
        if (measure == "Volume") org = "acúmulo";
        else if (organization == "raw") org = "bruto";
        else if (organization == "avg") org = "média";
        else if (organization == "occ") org = "ocorrência";
        else if (organization == "day") org = "";
      }

      if (this.reportData.TITLE_REPORT) {
        return this.reportData.TITLE_REPORT;
      }
      return `${measure}${org ? " (" + org + ")" : ""}`;
    },
    start() {
      return this.reportData.start
        ? this.formatDateTime(this.reportData.start)
        : "?";
    },
    end() {
      return this.reportData.end
        ? this.formatDateTime(this.reportData.end)
        : "?";
    },
    interval() {
      if (this.reportData.interval >= 1) return this.reportData.interval + "h";
      else return (this.reportData.interval == 0.5 ? "30" : "5") + "min";
    },
  },
  mounted() {
    this.progressbarWait = {
      show: () => this.$refs.progressWait.show(),
      hide: () => this.$refs.progressWait.hide(),
    };
  },
  watch: {
    progress(value) {
      if (value == this.progressMax) {
        setTimeout(() => {
          this.progressbarWait.hide();
          this.showTabulator = true;
          this.progressMax = 1;
          this.progress = 0;
          this.logsProgressBar = "";
        }, 1000);
      }
    },
  },
  methods: {
    async prepareBoostedVolDailyReport(datas) {
      try {
        this.genericStartReport();
        const { start, end, elements, START_HOUR, PICKED_COLUMNS } = datas;

        const data = (
          await reports.getActuatorsBaseReport({
            start,
            end,
            startHour: START_HOUR,
            pickedColumns: PICKED_COLUMNS,
            elements,
          })
        ).data;

        const columns = [
          "TEMPO",
          "VOLUME",
          "VAZAO MEDIA EFETIVA",
          "VAZAO MEDIA",
          "TEMPO ACIONADA",
        ];

        const organization = "raw";
        const interval_formatted = "24h";
        const observation = `Hora inicial: ${
          START_HOUR < 0 ? -1 * START_HOUR : START_HOUR
        }h ${START_HOUR < 0 ? "do dia anterior" : "do dia atual"}`;

        this.genericCreateReport({
          data,
          datas,
          columns,
          organization,
          interval_formatted,
          observation,
        });

        await this.genericReportSuccess();
      } catch (e) {
        console.log(e);
        return await this.genericReportFail();
      }
    },
    async prepareHydroAccReport(datas) {
      try {
        this.genericStartReport();

        const diffDays =
          moment(datas.end).diff(moment(datas.start), "days") + 1;

        const resp = await reports.getHydroAccVolume({
          start: `${datas.start} ${datas.START_TIME}`,
          end: `${datas.end} ${datas.END_TIME}`,
          equipments: datas.elements.map((equip) => equip.NAME),
        });

        const columns = [];
        const map = {};
        const totalRow = { PERIODO: "TOTAL" };

        for (const [equip, logs] of Object.entries(resp)) {
          columns.push(equip);

          let total = 0;

          logs.forEach(({ time, value }) => {
            if (!map[time]) map[time] = { PERIODO: time };

            map[time][equip] = value;

            total += value;
          });

          totalRow[equip] = total;
        }

        const data = Object.values(map);

        data.push(totalRow);

        const organization = "raw";
        const interval_formatted = `${diffDays} dias`;

        this.genericCreateReport({
          data,
          datas,
          columns,
          organization,
          interval_formatted,
          removeFirstColFormat: true,
        });

        await this.genericReportSuccess();
      } catch (e) {
        console.log(e);
        return await this.genericReportFail();
      }
    },
    formatInterval(seconds) {
      const secToMins = seconds / 60;
      if (secToMins < 60) {
        return `${secToMins}min`;
      } else {
        return "1h";
      }
    },
    downloadCSVEspecialReports() {
      this.$refs.dataTable.downloadCSV();
    },
    downloadPDFEspecialReports() {
      this.$refs.dataTable.downloadPDF();
    },
    downloadXLSXEspecialReports() {
      this.$refs.dataTable.downloadCSV();
    },
    generateUnionSensorsTime(sensors, start, end) {
      let rawUnion = "";

      for (const [index, element] of sensors.entries()) {
        rawUnion += `
          SELECT \`TIME\` FROM LOG_SENSOR.\`${element.NAME}\`
          WHERE DATE(\`TIME\`) BETWEEN '${start}' AND '${end}'
        `;

        if (index !== sensors.length - 1) {
          rawUnion += `UNION`;
        }
      }

      return rawUnion;
    },
    async getAllSensorsData(datas) {
      const { elements: sensors, start, end } = datas;

      return await Promise.all(
        sensors.map(async (element, index) => {
          const sensorType = `'${element.TYPE}'`;
          const elementName = element.NAME;

          const rawHourly = `
          SELECT S0.TEMPO AS TEMPO,
          FORMAT(IF(S0.TEMPO BETWEEN @DATAMIN_1 AND @DATAMAX_1, IF(S1.MEDIA_FIL IS NULL, @LAG1, @LAG1 := S1.MEDIA_FIL), 0), 2)+0 AS '${
            element.VALUE_KEY
          }'
          FROM
              ((SELECT DISTINCT DATE_FORMAT(\`TIME\`, '%Y-%m-%d %H:00:00') AS TEMPO
              FROM (${this.generateUnionSensorsTime(
                sensors,
                start,
                end
              )}) AS TEMPOS
                  ORDER BY TEMPO) AS S0
              LEFT JOIN
              (SELECT TEMPO,
                      AVG(IF(((SENSOR - MEDIA) BETWEEN -1.8*(DESV + MEDIA/100) AND 1.8*(DESV + MEDIA/100)), SENSOR, NULL)) AS MEDIA_FIL
              FROM
                  (SELECT TEMPO, SENSOR, MEDIA, DESV FROM
                      (SELECT DATE_FORMAT(\`TIME\`, '%Y-%m-%d %H:00:00') AS TEMPO,
                      IF(DAY(\`TIME\`) % 2 = 1, DATE(\`TIME\`) + INTERVAL(IF(DAY(\`TIME\`) = 31, -1, 1)) DAY, DATE(\`TIME\`)) AS AVG_TIME,
                      VALUE AS SENSOR FROM LOG_SENSOR.\`${elementName}\`
                      WHERE (DATE(\`TIME\`) BETWEEN '${start}' AND '${end}')
                      AND \`TYPE\` = ${sensorType}) AS ORIGINAL
                  LEFT JOIN
                      (SELECT
                      IF(DAY(\`TIME\`) % 2 = 1, DATE(\`TIME\`) + INTERVAL(IF(DAY(\`TIME\`) = 31, -1, 1)) DAY, DATE(\`TIME\`)) AS AVG_TIME,
                      AVG(VALUE) AS MEDIA,
                      IFNULL(STDDEV_SAMP(VALUE),0) AS DESV
                      FROM LOG_SENSOR.\`${elementName}\`
                      WHERE (DATE(\`TIME\`) BETWEEN '${start}' AND '${end}')
                      AND \`TYPE\` = ${sensorType}
                      GROUP BY 1) AS MEDIA
                  ON ORIGINAL.AVG_TIME = MEDIA.AVG_TIME) AS FILTRADO
              GROUP BY TEMPO
              HAVING MEDIA_FIL IS NOT NULL) AS S1
              ON S0.TEMPO = S1.TEMPO),
              (SELECT @LAG1 := 0,
                      @DATAMAX_1 := (SELECT DATE_FORMAT(MAX(\`TIME\`), '%Y-%m-%d %H:00:00') FROM LOG_SENSOR.\`${elementName}\`),
                      @DATAMIN_1 := (SELECT DATE_FORMAT(MIN(\`TIME\`), '%Y-%m-%d %H:00:00') FROM LOG_SENSOR.\`${elementName}\`)) AS VARS
        `;

          const rawDaily = `
                SELECT S0.TEMPO,
              FORMAT(IF(S0.TEMPO BETWEEN @DATAMIN_1 AND @DATAMAX_1, S1.MEDIA_FIL, 0),2)+0 AS '${
                element.VALUE_KEY
              }'
        FROM
            ((SELECT DISTINCT DATE(\`TIME\`) AS TEMPO
            FROM (${this.generateUnionSensorsTime(
              sensors,
              start,
              end
            )}) AS TEMPOS
                ORDER BY TEMPO) AS S0
            LEFT JOIN
            (SELECT TEMPO,
                    AVG(IF(((SENSOR - MEDIA) BETWEEN -1.8*(DESV + MEDIA/100) AND 1.8*(DESV + MEDIA/100)), SENSOR, NULL)) AS MEDIA_FIL
            FROM
                (SELECT TEMPO, SENSOR, MEDIA, DESV FROM
                    (SELECT DATE(\`TIME\`) AS TEMPO,
                    IF(DAY(\`TIME\`) % 2 = 1, DATE(\`TIME\`) + INTERVAL(IF(DAY(\`TIME\`) = 31, -1, 1)) DAY, DATE(\`TIME\`)) AS AVG_TIME,
                    VALUE AS SENSOR FROM LOG_SENSOR.\`${elementName}\`
                    WHERE (DATE(\`TIME\`) BETWEEN '${start}' AND '${end}')
                    AND \`TYPE\` = ${sensorType}) AS ORIGINAL
                LEFT JOIN
                    (SELECT
                    IF(DAY(\`TIME\`) % 2 = 1, DATE(\`TIME\`) + INTERVAL(IF(DAY(\`TIME\`) = 31, -1, 1)) DAY, DATE(\`TIME\`)) AS AVG_TIME,
                    AVG(VALUE) AS MEDIA,
                    IFNULL(STDDEV_SAMP(VALUE),0) AS DESV
                    FROM LOG_SENSOR.\`${elementName}\`
                    WHERE (DATE(\`TIME\`) BETWEEN '${start}' AND '${end}')
                    AND \`TYPE\` = ${sensorType}
                    GROUP BY 1) AS MEDIA
                ON ORIGINAL.AVG_TIME = MEDIA.AVG_TIME) AS FILTRADO
            GROUP BY TEMPO
            HAVING MEDIA_FIL IS NOT NULL) AS S1
            ON S0.TEMPO = S1.TEMPO),
            (SELECT
                @DATAMAX_1 := (SELECT DATE(MAX (\`TIME\`)) FROM LOG_SENSOR.\`${elementName}\`),
                @DATAMIN_1 := (SELECT DATE(MIN (\`TIME\`)) FROM LOG_SENSOR.\`${elementName}\`)) AS VARS
        `;

          const raw = datas.type === "measure-daily" ? rawDaily : rawHourly;

          const sensorValues = await management
            .sql({
              data: {
                sql: raw,
              },
            })
            .then((ret) => {
              return ret[0] && ret[0].length ? ret[0] : [];
            })
            .catch((err) => {
              console.log("error on volume hourly report, ", err);
              alert(`Ocorreu um erro ao buscar o relatório.`, "w");
              return [];
            });

          this.progress += 1;

          return sensorValues;
        })
      );
    },
    async prepareManagementDailyReport() {
      this.$refs.progressWait.show();

      const management_actuators = await this.getManagementSectorsActuators();

      if (management_actuators.length) {
        const management_sectors_today_infos =
          await this.getManagementSectorsDailyStatus(management_actuators);

        await Promise.all(
          management_sectors_today_infos.map(async (sector) => {
            const transmissivity =
              sector.SYSTEM_EFFICIENCY * sector.SOIL_TRANSMISSIVITY;
            sector.IRRIGATED_BLADE = this.calcIrrigatedBlade(
              sector.SCHEDULE_VOLUME_PREVIEW,
              sector.AREA,
              transmissivity
            );

            const hasScheduleTodayText = `${
              (sector.SCHEDULE_VOLUME_PREVIEW &&
                sector.SCHEDULE_VOLUME_PREVIEW.toFixed(2)) ||
              0
            }m³ (${sector.IRRIGATED_BLADE}mm) em ${
              sector.SCHEDULE_DURATION
            }min`;
            const fallBackScheduleText = "Não há agenda programada para hoje";
            sector.IRRIGATED_BLADE_INFOS = sector.SCHEDULE_DURATION
              ? hasScheduleTodayText
              : fallBackScheduleText;

            const BLADE_SUGGESTION_VOLUME = this.lam2vol(
              sector.BLADE_SUGGESTION,
              Number(sector.AREA),
              transmissivity
            );
            let BLADE_SUGGESTION_MINUTES;

            if (sector.FLOW_AVG) {
              BLADE_SUGGESTION_MINUTES =
                (BLADE_SUGGESTION_VOLUME / sector.FLOW_AVG) * 60;
            } else {
              BLADE_SUGGESTION_MINUTES =
                (sector.BLADE_SUGGESTION * 60) /
                transmissivity /
                sector.APPLICATION_RATE;
            }

            BLADE_SUGGESTION_MINUTES = Math.round(BLADE_SUGGESTION_MINUTES);
            sector.BLADE_SUGGESTION_INFOS = `${
              (BLADE_SUGGESTION_VOLUME && BLADE_SUGGESTION_VOLUME.toFixed(2)) ||
              0
            }m³ (${
              sector.BLADE_SUGGESTION
            }mm) em ${BLADE_SUGGESTION_MINUTES}min`;

            const [finalStorage, excess] = [
              ...this.calcFinalStorage({
                ETR: sector.ETR_PREDICTION,
                PRECIPITATION: sector.PRECIPITATION,
                INITIAL_STORAGE: sector.INITIAL_STORAGE,
                MAX_STORAGE: sector.MAX_STORAGE,
                RAINFALL: sector.RAINFALL,
                RAINFALL_INPUT: sector.RAINFALL_INPUT,
                IRRIGATED_BLADE: sector.IRRIGATED_BLADE,
              }),
            ];

            sector.FINAL_STORAGE = finalStorage;

            sector.EXCESS = excess;
          })
        );

        this.$refs.progressWait.hide();
        return management_sectors_today_infos;
      } else {
        this.$refs.progressWait.hide();
        return [];
      }
    },
    async prepareStationReport(datas) {
      try {
        this.genericStartReport();
        const { start, end, readTime } = datas;

        const data = (await this.getStationReport({ start, end, readTime }))
          .data;

        const columns = [
          "TEMPO",
          "DIRECAO_DO_VENTO",
          "PLUVIOMETRIA",
          "PRESSAO_ATMOSFERICA",
          "RADIACAO_SOLAR",
          "TEMPERATURA_DO_AR",
          "UMIDADE_RELATIVA_DO_AR",
          "VELOCIDADE_DO_VENTO",
        ];

        const organization = "raw";
        const interval_formatted = this.formatInterval(readTime);

        this.genericCreateReport({
          data,
          datas,
          columns,
          organization,
          interval_formatted,
        });

        await this.genericReportSuccess();
      } catch (e) {
        return await this.genericReportFail();
      }
    },
    genericStartReport() {
      this.logsProgressBar = "Reunindo dados...";
      this.$refs.progressWait.show();
      this.progressMax = 100;
      this.progress = 0;
    },
    genericCreateReport({
      data,
      datas,
      columns,
      organization,
      interval_formatted,
      observation,
      removeFirstColFormat,
    }) {
      const tableData = [
        ...data.map((data) => {
          const valuesData = Object.values(data);
          const roundedValues = valuesData.map((val) =>
            typeof val === "number" ? Number(val.toFixed(4)) : val
          );

          return roundedValues;
        }),
      ];

      const showingColumns =
        data && data[0] && data[0] ? Object.keys(data[0]) : columns;

      this.createTable([showingColumns, ...tableData], {
        removeFirstColFormat,
      });
      this.reportData = datas;
      this.reportData.observation = observation;
      this.reportData.organization = organization;
      this.reportData.interval_formatted = interval_formatted;

      this.hasReport = true;
    },
    async genericHideLoadReport() {
      await setTimeout(() => {
        this.$refs.progressWait.hide();
        this.progress = this.progressMax;
        this.showForm = false;
      }, 200);
    },
    async genericReportFail() {
      alert("Ocorreu um erro ao buscar o relatório.", "w");

      await this.genericHideLoadReport();
    },
    async genericReportSuccess() {
      alert("Relatório gerado com sucesso.", "s");

      await this.genericHideLoadReport();
    },
    async getManagementSectorsActuators() {
      const raw = `
          SELECT CAD_VALVE.NAME
          FROM CROP.CAD_SECTOR CROP_SECTOR
          JOIN NEWSIR.CAD_SECTOR NEWSIR_SECTOR
          ON (
            NEWSIR_SECTOR.ID = CROP_SECTOR.ID_SECTOR
            AND CROP_SECTOR.IS_MANAGEMENT = 1
            AND IF(CROP_SECTOR.DATE_CROP = '', TRUE, CROP_SECTOR.DATE_CROP >= DATE(NOW()))
          )
          JOIN NEWSIR.SECTOR_HAS_VALVE SECTOR_HAS_VALVE
          ON SECTOR_HAS_VALVE.ID_SECTOR = NEWSIR_SECTOR.ID
          JOIN NEWSIR.CAD_VALVE CAD_VALVE
          ON CAD_VALVE.ID = SECTOR_HAS_VALVE.ID_VALVE
          WHERE CAD_VALVE.NAME IN (
            SELECT TABLE_NAME
            FROM information_schema.TABLES
            WHERE TABLE_SCHEMA = 'LOG_ACTUATOR'
          )
          GROUP BY CAD_VALVE.NAME;
        `;

      return await management
        .sql({
          data: {
            sql: raw,
          },
        })
        .then((ret) => {
          return ret[0] && ret[0].length
            ? ret[0].map((actuator) => actuator.NAME)
            : [];
        })
        .catch((err) => {
          console.log("error on management daily report, ", err);
          return [];
        });
    },
    async prepareSensorAverageReports(datas) {
      const { elements } = datas;

      this.logsProgressBar = "Reunindo dados...";
      this.$refs.progressWait.show();
      this.progressMax = elements.length;
      this.progress = 0;

      elements.map((element) => {
        element.VALID_FORMAT_TYPE = element.TYPE.replace(/ /g, "_");
        element.VALUE_KEY = `${element.NAME}_${element.VALID_FORMAT_TYPE}`;

        return element;
      });

      function mergeSensorsValues(sensorsElements, sensorsData) {
        const mergedData = sensorsData[0].map((row) => {
          return {
            TEMPO: row.TEMPO,
          };
        });

        for (let i = 0; i < sensorsData[0].length; i++) {
          const currentRow = mergedData[i];

          for (let j = 0; j < sensorsElements.length; j++) {
            const currentSensor = sensorsElements[j];
            const currentSensorNameUnique = currentSensor.VALUE_KEY;
            const currentSensorValue =
              sensorsData[j][i][currentSensor["VALUE_KEY"]];

            currentRow[currentSensorNameUnique] = currentSensorValue;
          }
        }

        return mergedData;
      }

      const allSensorsData = await this.getAllSensorsData(datas);
      const sensorsDataToServe = mergeSensorsValues(elements, allSensorsData);
      const sensorsColumns = elements.map((element) => {
        return {
          title: `${element.NAME} (${element.UNIT}) - ${element.VALID_FORMAT_TYPE}`,
          field: element.VALUE_KEY,
          minWidth: 150,
          hozAlign: "center",
          accessorDownload: (val) => Number(val),
        };
      });

      const dataToCreateTable = [
        [
          "PERÍODO",
          ...elements.map(
            (element, index) =>
              `${element.NAME} - ${element.TYPE} [${
                elements.length - 1 - index
              }]  (${element.UNIT})`
          ),
        ],
        ...sensorsDataToServe.map((sensorData) => Object.values(sensorData)),
      ];

      this.createTable(dataToCreateTable);
      this.reportData = datas;
      this.reportData.organization = "avg";
      this.reportData.interval = datas.type === "measure-daily" ? 24 : 1;

      this.hasReport = true;

      setTimeout(() => {
        this.$refs.progressWait.hide();
        this.progress = this.progressMax;
        this.showForm = false;
      }, 200);
    },
    async getStationReport({ start, end, readTime }) {
      try {
        return await stations.getStationRead({ start, end, readTime });
      } catch (e) {
        console.error("Erro no get station report", e);
      }
    },
    async getManagementSectorsDailyStatus(actuators) {
      let unionOfActuatorsTablesQuery = "";

      for (const [index, actuator] of actuators.entries()) {
        let flowAvgOfActuatorQuery = `
          SELECT
              FK_EQP,
              IFNULL(AVG(FLOW), 0) AS FLOW
          FROM LOG_ACTUATOR.\`${actuator}\`
          WHERE (
                DATE(TIME) <= DATE_ADD(DATE(NOW()), INTERVAL -1 DAY)
                AND DATE(TIME) >= DATE_ADD(DATE(NOW()), INTERVAL -15 DAY)
                AND FLOW > 0
                AND OPEN = 1
          )`;

        unionOfActuatorsTablesQuery += flowAvgOfActuatorQuery;

        if (index != actuators.length - 1) {
          unionOfActuatorsTablesQuery += "\nUNION ALL";
        }
      }

      const raw = `
      SELECT
          NEWSIR_SECTOR.ID,
          MANAGEMENT.TIME,
          C_USER.NAME AS EDITOR_NAME,
          IF(NEWSIR_SECTOR.PLANTING_DATE > DATE(NOW()), 0, DATEDIFF(DATE_ADD(DATE(NOW()), INTERVAL 1 DAY), NEWSIR_SECTOR.PLANTING_DATE)) AS NDC,
          NEWSIR_SECTOR.NAME AS SECTOR_NAME,
          FARMS.NAME AS FARM_NAME,
          SOIL.NAME AS SOIL_NAME,
          SOIL.TRANSMISSIVITY AS SOIL_TRANSMISSIVITY,
          CAD_VALVE.NAME AS ACTUATOR_NAME,
          AGN_INFOS.SCHEDULE_NAME AS SCHEDULE_NAME,
          SUM(AGN_INFOS.TIME) as SCHEDULE_DURATION,
          SUM(AGN_INFOS.TIME)/60 * ACTUATORS.FLOW AS SCHEDULE_VOLUME_PREVIEW,
          NEWSIR_SECTOR.AREA,
          CROP_SECTOR.SYSTEM_EFFICIENCY,
          CROP_SECTOR.APPLICATION_RATE,
          FARMS_DAP.AVAILABILITY,
          FARMS_DAP.DAP,
          FARMS_DAP.KC,
          FARMS_DAP.DEPTH_ROOT,
          FARMS_DAP.BRANCH,
          FARMS_DAP.PRECIPITATION,
          MANAGEMENT.INITIAL_STORAGE,
          MANAGEMENT.ET0_PREDICTION,
          MANAGEMENT.ETR_PREDICTION,
          MANAGEMENT.ETC,
          MANAGEMENT.RAINFALL,
          MANAGEMENT.RAINFALL_INPUT,
          MANAGEMENT.MAX_STORAGE,
          MANAGEMENT.BLADE_SUGGESTION,
          ACTUATORS.FLOW AS FLOW_AVG
        FROM CROP.CAD_SECTOR CROP_SECTOR
        JOIN NEWSIR.CAD_SECTOR NEWSIR_SECTOR
        ON (
          NEWSIR_SECTOR.ID = CROP_SECTOR.ID_SECTOR
          AND CROP_SECTOR.IS_MANAGEMENT = 1
          AND IF(CROP_SECTOR.DATE_CROP = '', true, CROP_SECTOR.DATE_CROP >= DATE(NOW()))
        )
        JOIN NEWSIR.SECTOR_HAS_VALVE SECTORS_VALVE
        ON SECTORS_VALVE.ID_SECTOR = NEWSIR_SECTOR.ID
        JOIN CROP.MANAGEMENT MANAGEMENT
        ON (
          MANAGEMENT.ID_SECTOR = NEWSIR_SECTOR.ID
          AND DATE(MANAGEMENT.TIME) = DATE(NOW())
        )
        JOIN CROP.FARMS_DAP FARMS_DAP
        ON (
          FARMS_DAP.DAP = MANAGEMENT.ID_DAP
          AND CROP_SECTOR.ID_FARM = FARMS_DAP.ID_FARM
        )
        JOIN NEWSIR.CAD_VALVE CAD_VALVE
        ON CAD_VALVE.ID = SECTORS_VALVE.ID_VALVE
        LEFT JOIN (
          SELECT
            TIME,
            NAME,
            FK_VALVE,
            NAME SCHEDULE_NAME
          FROM NEWSIR.AGN_VALVE
          JOIN NEWSIR.AGN_DURATION AGN_DURATION
          ON AGN_DURATION.ID = AGN_VALVE.FK_DURATION
          JOIN NEWSIR.AGN_TIME AGN_TIME
          ON (
            AGN_TIME.ID = AGN_VALVE.FK_AGN
            -- CHECK IF TODAY IS BETWEEN SCHEDULE DAYS RUNNING
            AND DATE(AGN_TIME.START_DATE) <= DATE(NOW())
            AND IF(ISNULL(AGN_TIME.END_DATE), TRUE, DATE(AGN_TIME.END_DATE) >= DATE(NOW()))
            AND (AGN_TIME.ACTIVITY_DAYS & POWER(2, (DAYOFWEEK(NOW()) - 1 ))) =  POWER(2, (DAYOFWEEK(NOW()) - 1 ))
          )
        ) AGN_INFOS
        ON AGN_INFOS.FK_VALVE = SECTORS_VALVE.ID_VALVE
        LEFT JOIN (${unionOfActuatorsTablesQuery}
        ) ACTUATORS
        ON ACTUATORS.FK_EQP = CAD_VALVE.ID
        JOIN CROP.FARM FARMS
        ON FARMS.ID = CROP_SECTOR.ID_FARM
        JOIN CROP.SOIL SOIL
        ON SOIL.ID = CROP_SECTOR.ID_SOIL
        LEFT JOIN NEWSIR.CAD_USER AS C_USER
        ON NEWSIR_SECTOR.FK_EDITOR = C_USER.ID
        GROUP BY NEWSIR_SECTOR.ID
        ORDER BY NEWSIR_SECTOR.NAME;
      `;
      /*        LEFT JOIN NEWSIR.CAD_USER AS C_USER
        ON NEWSIR_SECTOR.FK_EDITOR = C_USER.ID*/

      return await management
        .sql({
          data: {
            sql: raw,
          },
        })
        .then((ret) => {
          return ret[0] && ret[0].length ? ret[0] : [];
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    downloadReport() {
      let table = document.querySelector("#tableCreate");
      let tab_text = `<table>`;
      for (let j = 0; j < table.rows.length; j++) {
        tab_text += `<tr>${table.rows[j].innerHTML}</tr>`;
      }
      tab_text += `</table>`;
      let fileName = `relatorio${this.parseType}${this.reportData.start
        .split(" ")
        .join("")}-${this.reportData.end.split(" ").join("")}.xls`;
      let ua = window.navigator.userAgent;
      let msie = ua.indexOf("MSIE ");
      if (msie > -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        txtArea1.document.open("txt_html", "replace");
        txtArea1.document.write("sep=,\r\n" + tab_text);
        txtArea1.document.close();
        txtArea1.focus();
        sa = txtArea1.document.execCommand("SaveAs", true, fileName);
        return sa;
      } else {
        let a = document.createElement("a");
        a.href =
          "data:application/vnd.ms-excel;charset=UTF-8," +
          encodeURIComponent(tab_text);
        a.download = fileName;
        a.click();
      }
    },
    putInAlfabeticOrder(data) {
      let messy = data[0];
      let messy2 = data[0];
      let ordered = messy.filter((value) => messy.indexOf(value) > 0).sort();
      let indexArr = ordered.map((value) => messy.indexOf(value));
      indexArr.splice(0, 0, 0);
      let orderedTable = [];
      for (let i = 0; i < data.length; i++) {
        orderedTable.push([]);
      }
      let lenIndexArr = indexArr.length; //número de colunas
      let lenData = data.length; //número de linhas
      for (let x = 0; x < lenIndexArr; x++) {
        for (let i = 0; i < lenData; i++) {
          orderedTable[i].push(data[i][indexArr[x]]);
          if (x + 1 >= lenIndexArr && i + 1 >= lenData) {
            return orderedTable;
          }
        }
      }
    },
    formatTableValue(data) {
      //Se vier com ' ' irá tratar
      if (typeof data === "string" && data.replace(/\s/g, "") == "") {
        return "-";
      }
      return data;
    },
    createTable(tableDatas, { removeFirstColFormat } = {}) {
      this.tableData = [];
      this.columns = [];
      this.showTabulator = false;
      this.logsProgressBar = "Montando exibição...";

      new Promise((resolve, reject) => {
        let orderedData = this.putInAlfabeticOrder(tableDatas);
        let column = orderedData[0].length;
        let columns = [];
        let tableData = [];
        let rows = orderedData.length;
        let c = [];
        for (let i = 0; i < rows; i++) {
          let col = {};
          for (let j = 0; j < column; j++) {
            if (i == 0) {
              let fieldColumn = orderedData[i][j];
              if (typeof fieldColumn === "string") {
                fieldColumn = fieldColumn
                  .replace(
                    /[^a-z-A-Z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'S]/g,
                    ""
                  )
                  .replace(/-/g, "");
              }
              columns.push({
                title: orderedData[i][j],
                // field: `c-${j}`,
                field: `c-${fieldColumn}-${j}`,
                // width: 150,
                minWidth: 400,
                headerSort: false,
                hozAlign: "center",
              });
            } else {
              //PERÍODO ou DATA
              if (j == 0 && !removeFirstColFormat) {
                col = Object.assign(col, {
                  id: i,
                  minWidth: 150,
                  [columns[j].field]: this.formatDateTime(orderedData[i][j]),
                  hozAlign: "center",
                });
              } else {
                col = Object.assign(col, {
                  id: i,
                  minWidth: 150,
                  [columns[j].field]: this.formatTableValue(orderedData[i][j]),
                  hozAlign: "center",
                });
              }
            }
          }
          if (Object.keys(col).length) tableData.push(col);
        }
        resolve([columns, tableData]);
      }).then((t) => {
        this.columns = t[0];
        this.tableData = t[1];
        this.showTabulator = true;
        setTimeout(() => (this.progress += 1), 700);
      });

      // myTableDiv.appendChild(table);
      // wait.hide();
    },
    formatDateTime(dateTime) {
      let date = dateTime.split(" ")[0];
      let splittedDate = date.split("-");
      let time = dateTime.split(" ")[1];
      return time
        ? splittedDate[2] +
            "/" +
            splittedDate[1] +
            "/" +
            splittedDate[0] +
            " " +
            time
        : splittedDate[2] + "/" + splittedDate[1] + "/" + splittedDate[0];
    },
    openReportForm() {
      this.showForm = true;
    },
    removeRepeatedTimes(table) {
      const flatArray = [...table.flat()];
      flatArray.sort(function (a, b) {
        var c = new Date(a);
        var d = new Date(b);
        return d - c;
      });
      const filteredData = flatArray.reduce((ac, time) => {
        if (ac.indexOf(time) < 0) ac.push(time);
        return ac;
      }, []);
      return Array.from([...filteredData], (t) => Array.of(t));
    },
    removeRepeatedTimesVol(table) {
      const flatArray = [...table.flat()];
      flatArray.sort(function (a, b) {
        var c = new Date(a);
        var d = new Date(b);
        return c - d;
      });
      const filteredData = flatArray.reduce((ac, time) => {
        if (ac.indexOf(time) < 0) ac.push(time);
        return ac;
      }, []);
      return Array.from([...filteredData], (t) => Array.of(t));
    },
    //Criar uma coluna para cada POS do sensor
    sensorLogsPerPos(logs) {
      const onlyTimes = this.getTimes(logs);
      let noRepeatedTimes = this.removeRepeatedTimes(onlyTimes);
      // Dados agrupados por POS
      let newTables = [];

      noRepeatedTimes.forEach((notRepeated) => {
        //Vai selecionar os elementos com a mesma data de notRepeated[0]
        //e agrupar ele s no array
        let sameTimeItems = logs.filter((item, i) => {
          if (item.TIME === notRepeated[0]) {
            return true;
          }
        });
        //Checar POS dos sensores para caso tenha algum item repetido (Com mesmos atributos)
        if (sameTimeItems.length > 1) {
          const samePos = (prev, curr) => (prev.POS == curr.POS ? prev : false);
          const everySamePOS = !!sameTimeItems.reduce(samePos);
          //Se POS for igual a todos os items
          if (everySamePOS) {
            const dif = sameTimeItems.filter(
              (el, i) =>
                i === sameTimeItems.findIndex((item) => item.NOTE === el.NOTE)
            );
            //Se for tudo igual retorna a primeira ocorrência
            if (dif.length == 1) {
              //Pega o primeiro
              sameTimeItems = dif;
            } else if (dif.length > 1) {
              // Priorizar o que tem NOTE
              let firstOccurrence = dif.find((i) => i.NOTE);
              sameTimeItems = [firstOccurrence];
            }
          }
          //Preparar para gerar relatório com coluna para cada posição (POS)
          else {
            const uniqueArray = [];
            //REMOVER OS DUPLICADOS
            for (let item of sameTimeItems) {
              let alreadyExists = uniqueArray.findIndex(
                (el) => el.POS == item.POS
              );
              if (alreadyExists < 0) {
                uniqueArray.push(item);
              } else {
                //SE ALGUM TIVER NOTE => DEIXAR O QUE TEM NOTE
                if (!uniqueArray[alreadyExists].NOTE && item.NOTE) {
                  uniqueArray[alreadyExists] = item;
                }
                //SE ALGUM TIVER NOTE => DEIXAR O QUE TEM NOTE
                else if (uniqueArray[alreadyExists].NOTE && !item.NOTE) {
                  continue;
                }
                // SE NENHUM TIVER NOTE => DEIXAR O PRIMEIRO
                else if (!uniqueArray[alreadyExists].NOTE && !item.NOTE) {
                  continue;
                }
                // SE TODOS TIVER NOTE => DEIXA O PRIMEIRO
                else if (uniqueArray[alreadyExists].NOTE && item.NOTE) {
                  continue;
                }
              }
            }
            sameTimeItems = uniqueArray;
          }
        }
        //Cada índice será uma coluna
        sameTimeItems.forEach((item, i) => {
          let hasIndex = i in newTables;
          //Se não tiver uma chave no array, irá criar a chave e valor
          //para ir adicionando os items com mesma chave no array
          if (!hasIndex) {
            newTables[i] = [];
          }

          //Renomear TYPE adicionando POS
          item.TYPE += ` [${item.POS}] `;

          //Agrupa item com mesmo POS no mesmo índice
          newTables[i].push(item);
        });
      });
      return { logs: newTables, table: noRepeatedTimes };
    },

    async loadAllReports(data) {
      let allReports = [];

      try {
        for (const element of data.elements) {
          this.logsProgressBar = `Carregando ${element.NAME}`;
          await new Promise((resolve) => setTimeout(resolve, 600));
          const report_data = await reports.search({
            ...data,
            elements: element,
          });

          if (report_data && report_data[0] && report_data[0][0].IS_FIR) {
            report_data[0].map((log) => {
              if (log.NOTE && log.NOTE.toUpperCase().includes("DESATIVADO")) {
                log.OPEN = 1;
              } else if (
                (log.NOTE && log.NOTE.toUpperCase().includes("ATIVADO")) ||
                log.OPEN
              ) {
                log.VOL = 0;
                log.OPEN = 1;
              } else {
                log.OPEN = 0;
                log.VOL = 0;
              }

              return log;
            });
          }

          allReports.push({ NAME: element.NAME, VALUE: report_data[0] });
          await new Promise((resolve) =>
            setTimeout(resolve((this.progress += 1)), 600)
          );
          // setTimeout(() => (this.progress += 1), 600);
        }
        if (allReports.length) {
          return Promise.resolve(allReports);
        }
      } catch (error) {
        setTimeout(() => (this.progress = this.progressMax), 200);
        return Promise.reject(
          "[ERROR] - Não foi possível buscar os dados dos relatórios"
        );
      }
    },
    getTimes(ret) {
      let times = ret.map((el) => {
        return [el.TIME];
      });
      return times;
    },
    sortLogs(type, logs) {
      if (type == "asc") {
        logs.sort(function (a, b) {
          var c = new Date(a.TIME);
          var d = new Date(b.TIME);
          return c - d;
        });
        return logs;
      } else {
        logs.sort(function (a, b) {
          var c = new Date(a.TIME);
          var d = new Date(b.TIME);
          return d - c;
        });
        return logs;
      }
    },
    concatReportsData(reports, datas, callback) {
      let tables = [];
      for (let ret of reports) {
        let reportsLogs = [];
        let reportsTable = [];
        if (ret.VALUE && ret.VALUE.length) {
          if (datas.equipment == "sensor") {
            //Separar sensores que possuem POS iguais, ou seja, que possuem medições diferentes
            // para o mesmo tempo, em teoria os sensores que possuem POS diferente mas com tempo
            //iguais
            const { logs, table } = this.sensorLogsPerPos(ret.VALUE);
            logs.forEach((log) => {
              reportsLogs = [...reportsLogs, { NAME: ret.NAME, VALUE: log }];
            });
            reportsTable = [...reportsTable, ...table];
            tables.push({ logs: reportsLogs, table: reportsTable });
          } else if (datas.equipment == "actuator") {
            //Volume tem que ter datas repetidas
            if (datas.type == "volume") {
              ret.VALUE.sort(function (a, b) {
                var c = new Date(a.TIME);
                var d = new Date(b.TIME);
                return c - d;
              });
              let only_times = this.getTimes(ret.VALUE);
              let noRepeatedTimes = this.removeRepeatedTimesVol(only_times);

              reportsLogs = [
                ...reportsLogs,
                { NAME: ret.NAME, VALUE: ret.VALUE },
              ];
              reportsTable = [...reportsTable, ...noRepeatedTimes];
            }
            // Irá remover as datas repetidas
            else {
              ret.VALUE.sort(function (a, b) {
                var c = new Date(a.TIME);
                var d = new Date(b.TIME);
                return d - c;
              });
              let only_times = this.getTimes(ret.VALUE);
              let noRepeatedTimes = this.removeRepeatedTimes(only_times);
              // let sortTimes=this.sortLogs('desc',noRepeatedTimes)
              reportsLogs = [
                ...reportsLogs,
                { NAME: ret.NAME, VALUE: ret.VALUE },
              ];
              reportsTable = [...reportsTable, ...noRepeatedTimes];
            }

            tables.push({ logs: reportsLogs, table: reportsTable });
          } else {
            //Ordenar os dados das requisições em ordem crescente
            let sortedLogs = this.sortLogs("asc", ret.VALUE);
            let only_times = this.getTimes(sortedLogs);

            reportsLogs = [
              ...reportsLogs,
              { NAME: ret.NAME, VALUE: ret.VALUE },
            ];
            reportsTable = [...reportsTable, ...only_times];
            tables.push({ logs: reportsLogs, table: reportsTable });
          }
        }
      }
      callback(tables);
    },
    async makeReport(datas) {
      if (
        !datas.length &&
        datas.type == "daily" &&
        datas.group == "management"
      ) {
        this.progress = 1;
        this.progressMax = 10;

        setTimeout(() => (this.progress = 2), 100);

        let management_daily_report = await this.prepareManagementDailyReport();
        //Estiver filtrando por usuário
        if (datas.elements.length) {
          const elements = datas.elements.map((el) => el.NAME);
          management_daily_report = management_daily_report.filter((item) =>
            elements.includes(item.EDITOR_NAME)
          );
        }

        this.tableData = management_daily_report;
        this.reportData.organization = "day";
        this.reportData = datas;

        this.progress = 100;
        this.hasReport = true;
        this.showEspecialReports = true;

        setTimeout(() => {
          this.showForm = false;
        }, 200);

        return;
      } else if (datas.type == "station-reads" && datas.group == "station") {
        return await this.prepareStationReport(datas);
      } else if (
        datas.equipment === "sensor" &&
        ["measure-hourly", "measure-daily"].includes(datas.type)
      ) {
        return await this.prepareSensorAverageReports(datas);
      } else if (
        datas.equipment === "actuator" &&
        datas.type === "actuators_base_report"
      ) {
        return await this.prepareBoostedVolDailyReport(datas);
      } else if (datas.equipment === "hydrometer" && datas.type === "volume") {
        return await this.prepareHydroAccReport(datas);
      }

      this.showEspecialReports = false;
      this.hasReport = true;
      this.showForm = false;
      this.progressMax += datas.elements.length;

      this.progressbarWait.show();

      this.loadAllReports(datas)
        .then((reports_data) => {
          if (reports_data.length) {
            let reports = {};
            this.concatReportsData(reports_data, datas, (result) => {
              if (result.length) {
                reports = result;
              } else {
                throw new Error("Falha ao formatar os dados dos relatórios");
              }
            });
            return reports;
          }
          throw new Error("Não foi possível buscar dados");
        })
        .then((reportInfo) => {
          let reports = JSON.parse(JSON.stringify(reportInfo)); //deep copy
          organizeToTable(reports, datas, (result) => {
            if (result.status) {
              removeItemsWithoutLog(result.table, (status, newTable) => {
                if (status) {
                  this.reportData = datas;
                  this.createTable(newTable[0]);
                } else {
                  setTimeout(() => (this.progress += 1), 200);
                  this.hasReport = false;
                  alert("Não há registros para o período.", "w");
                }
              });
            } else {
              throw new Error(
                "Não foi possível organizar os dados dos relatórios"
              );
            }
          });
        })
        .catch((err) => {
          alert(`Ocorreu um erro ao buscar o relatório.`, "w");
          this.hasReport = false;
          console.error(err);
          setTimeout(() => (this.progress = this.progressMax), 200);
        });
    },
  },
};
</script>

<style scoped>
.progress {
  background: #bdbdbd;
}
.box {
  height: 100%;
}
.no-report {
  height: 80vh;
  margin-left: -55px;
}
.report {
  height: 80vh;
}
.details-info {
  line-height: 0.5em;
}
.report-table {
  overflow-y: auto;
  overflow-x: hidden;
}
.btn-report {
  margin-top: 15px;
}
.table {
  border-collapse: collapse;
  width: 100%;
  margin: 15px 0 15px 0;
}
.table td,
.table th {
  border: 1px solid #eef2f5;
  padding: 8px;
}
.table tr:nth-child(even) {
  background-color: #eef2f5;
}
.table tr:hover {
  background-color: #bdbdbd;
}
.table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  color: #fff;
  background-color: #16526b;
}
@media screen and (max-width: 767px) {
  .no-report {
    margin-left: 0;
  }
  .monit-page {
    padding: 0;
  }
}
</style>
